/**
 * Drug-specific attestation copy for provider attestation checkbox.
 * Each drug has its own entry to allow for future customization.
 */

export type AttestationCopy = {
  headerPrefix: string;
  headerText: string;
  checkboxLabel: string;
};

const DEFAULT_HEADER_PREFIX = '(Optional) Patient Authorization:';

const EXPEDITED_HEADER_PREFIX = '(Optional) Patient Authorization for Expedited Enrollment';

const DEFAULT_HEADER_TEXT =
  'Check the box below to fax the patient enrollment form to the program without patient signature.';

const TREMFYA_HEADER_TEXT =
  'Check the box below to fax the Patient Enrollment Form to the program without patient signature. If this attestation is not selected, the form will be sent to the patient for signature and will not be submitted until both parties have signed.';

const DEFAULT_CHECKBOX_LABEL =
  'By checking this box, I authorize Tandem to share the below enrollment form directly with the program. Once you press "Submit," this form will not be sent to the patient for signature.';

const LILLY_HEADER_TEXT =
  "Check to authorize faxing the Patient Enrollment Form to the program without the patient's signature if the prior authorization is denied. If this attestation is not selected, the form will be sent to the patient for signature and will not be submitted until both parties have signed.";

const LILLY_CHECKBOX_LABEL =
  'By checking this box, I represent and warrant that I have on file authorization from the patient whose information I am submitting and have discussed enrollment into the program with the patient. Once you press "Submit" this form will not be sent to the patient for signature.';

export const ATTESTATION_CONFIG: Record<string, AttestationCopy> = {
  Tremfya: {
    headerPrefix: EXPEDITED_HEADER_PREFIX,
    headerText: TREMFYA_HEADER_TEXT,
    checkboxLabel: DEFAULT_CHECKBOX_LABEL,
  },
  Ebglyss: {
    headerPrefix: DEFAULT_HEADER_PREFIX,
    headerText: LILLY_HEADER_TEXT,
    checkboxLabel: LILLY_CHECKBOX_LABEL,
  },
  Taltz: {
    headerPrefix: DEFAULT_HEADER_PREFIX,
    headerText: LILLY_HEADER_TEXT,
    checkboxLabel: LILLY_CHECKBOX_LABEL,
  },
} as const;

/**
 * Get attestation copy for a drug. Falls back to default if drug not found.
 */
export function getAttestationCopy(drugName: string | null): AttestationCopy | null {
  if (!drugName) {
    return null;
  }
  return (
    ATTESTATION_CONFIG[drugName] ?? {
      headerPrefix: DEFAULT_HEADER_PREFIX,
      headerText: DEFAULT_HEADER_TEXT,
      checkboxLabel: DEFAULT_CHECKBOX_LABEL,
    }
  );
}
